import React, {useCallback, useEffect, useState} from 'react';
import {useLocation, useNavigate, useParams} from 'react-router';
import {useTranslation} from 'react-i18next';
import {Location} from 'history';
import {callNativeWeb, footerShowEventWeb} from 'common/appInterface';
import {CardProductTabName} from "../../constants/Card";

const TerminateResult: React.FC = () => {
	/** Location State */
	const location = useLocation() as Location<LocationState>;
	/** Navigate */
	const navigate = useNavigate();
	/** 다국어처리 */
	const {t, i18n} = useTranslation();
	
	const {result = ""} = useParams();
	
	const [cardInfo] = useState(location.state.info);
	
	const screenId = 'SERV21';
	const screenName = t('SERV21.title');
	
	const moveToMain = useCallback(() => {
			navigate("/main", {
				state: {
					query: location.state.query,
					swiperIndex: location.state.swiperIndex,
					tabIndex: location.state.tabIndex,
					from: location.pathname
				}
			});
		}, [navigate, location]
	);
	
	// 최초실행
	useEffect(() => {
		// 언어설정
		i18n.changeLanguage(location.state.query.languageCode);
		// callNative_Web 처리 (WEB > APP)
		callNativeWeb(screenId, screenName, location.state.from === '/intro' ? 'Y' : 'N');
		// 하단바 숨기기
		footerShowEventWeb('N');
		
		console.log('QUERY STATE');
		console.log(location.state);
		
		// 최초한번실행 useEffect() Warning 제거
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, []);
	
	// 뒤로가기 이벤트 리스너 (backKeyEvent_App (APP > WEB))
	useEffect(() => {
		document.addEventListener('backpress', moveToMain);
		return () => document.removeEventListener('backpress', moveToMain);
	}, [moveToMain]);
	
	return (
		<section className="pdb70">
			<div id="container">
				<section className="terminate">
					<div className="centerDiv">
						<img className="checkImg" src="/assets/images/ico/check.png" alt="check"/>
					</div>
					<div className="centerDiv">
						<span className="blueTitle">{t(`SERV21.subTitle.${result}`)}</span>
						{
							result === "progress" && (<div className="mgt8">
								<span className="text2">{t(`SERV21.content.${result}`)}</span>
							</div>)
						}
					</div>
					<div className="divider mgt25"/>
					<div className="betweenDiv">
						<span
							className="caption2">{t(`SERV21.${result === "cancel" ? 'card' : 'terminateCard'}`)}</span>
						<span className="subTitle">{CardProductTabName[Number(cardInfo.cardProductCode)]}</span>
					</div>
					<div className="divider"/>
					<div className="betweenDiv">
						<span className="caption2">{t('SERV21.cardNumber')}</span>
						<span className="subTitle">{cardInfo.cardNo}</span>
					</div>
					<div className="divider"/>
				</section>
				<div className="btnArea">
					<div className="btnWrapTy01">
						<button type="button" className="btnPrimaryTy01" onClick={moveToMain}>
							<span>{t('COMMON.button.done')}</span>
						</button>
					</div>
				</div>
			</div>
		</section>
	);
};

export default TerminateResult;